module.exports = __webpack_public_path__ + "static/media/login-background1-en.475c4a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background1-en.png
// module id = 1094
// module chunks = 110